import Vue from 'vue';
import spacetime from 'spacetime';

Vue.filter('upper', value => {
    if (typeof value === 'string') {
        return value.toUpperCase();
    } else {
        return value
    }
});

Vue.filter('lower', value => {
    if (typeof value === 'string') {
        return value.toLowerCase();
    } else {
        return value
    }
});

Vue.filter('capitalize', function (value) {
    if (typeof value === 'string') {
        return value.replace(/\b\w/g, function (l) {
            return l.toUpperCase()
        })
    } else {
        return value
    }
});


function getNumberOfDecimals(value) {
    value = value.toString();
    if (value.indexOf('.') !== -1) {
        return (value.split('.')[1]).length;
    } else {
        return 0;
    }
}

function decimalsCrypto(value, decimals) {
    let numberValue = parseFloat(value);
    if (decimals) {
        return parseFloat(numberValue.toFixed(decimals))
    } else {
        if (getNumberOfDecimals(value) < 2) {
            return numberValue.toFixed(2);
        } else {
            return numberValue;
        }

    }
}

Vue.filter('decimalsCrypto', (value, decimals) => {
    return decimalsCrypto(value, decimals)
});


Vue.filter('setDecimalsByCrypto', (value, coin) => {
    if (crypto && crypto.decimals) {
        return decimalsCrypto(value, crypto.decimals)
    } else {
        return decimalsCrypto(value)
    }
});

Vue.filter('toDate', (value) => { // from UNIX
    value = (parseInt(value) * 1000)
    return spacetime(value).format('dd.MM.yyyy');
});

Vue.filter('toDateTime', (value) => { // from UNIX
    value = (parseInt(value) * 1000)
    return spacetime(value).format('dd.MM.yyyy hh:mm');
});

Vue.filter('formatDateTime', (value) => {
    return spacetime(value).format('dd.MM.yyyy hh:mm:SS');
});

Vue.filter('decimals', function (value, decimals) {
    decimals = decimals || 2;
    let n = value ? parseFloat(value).toFixed(decimals) : value;
    return Number(n).toLocaleString("pt", { minimumFractionDigits: decimals });
});

Vue.filter('dynamicDecimals', function (value, isNextFiat) {
    if (!isNextFiat) {
        return value ? parseFloat(value).toFixed(8) : value;
    } else {
        let n = value ? parseFloat(value).toFixed(2) : value;
        return Number(n).toLocaleString("pt", { minimumFractionDigits: 2 });
    }

});

Vue.filter('percentage', (value, decimals) => {
    if (value) {
        decimals = decimals || 2;
        var formattedValue = parseFloat(value).toFixed(decimals);
        return formattedValue + "%";
    } else {
        return '-';
    }
})

Vue.filter('fixAddressWidth', (address, maxNumberOfAddressChars = 26) => {
    return address.length > maxNumberOfAddressChars ?
        address.substring(0, maxNumberOfAddressChars) :
        address
})

Vue.filter('json', (value) => {
    return JSON.stringify(value, null, 2)
})

Vue.filter('testeFunc', value => {
    console.log('testeeeeeee')
})




// WEBPACK FOOTER //
// ./src/utils/filters.js